// extracted by mini-css-extract-plugin
module.exports = {"slider-wrapper":"vape-strategy-swiper_slider-wrapper__51WSq"};